import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { PASPrdService } from '../../../services/PASPrd.service';
import { ErrorStateMatcher1 } from '../../error-state-matcher1';
//import { IgrouppaslistResponse } from '../../Interfaces/igrouppas';
import { ILocationProductionResponse } from '../../Interfaces/ilocation';
//import { GRPASCCV1Detail } from '../../Interfaces/ipas';
import { UpdatePO } from '../../Interfaces/iproduction';


@Component({
  selector: 'app-pasoptionupdate',
  templateUrl: './pasoptionupdate.component.html'
})

export class PASOptionUpdateComponent implements OnInit {
  formedit: FormGroup;
  subRef$: Subscription;
  matcher = new ErrorStateMatcher1();
  message: string = "";
  productionLocations: ILocationProductionResponse[];

  constructor(
    private formBuilder: FormBuilder,
    private PASPrdService:PASPrdService,
    private dialogRef: MatDialogRef<PASOptionUpdateComponent>,
    private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.formedit = formBuilder.group({
      option: ["", [Validators.required]],
      selected: [true, [Validators.required]],
      statusBol: [true, [Validators.required]],
      control: ['', [Validators.required]]
    });
  }
  //groupId: number;
  id: number;
  _Code: string;

  ngOnInit() {
    //this.groupId = this.data.groupId
    this.id = this.data.Id
    this.message = "";
    this.GetData();
  }

  GetData() {
    this.PASPrdService.GetPO(this.id).subscribe(result => {
      if (result.body.isValid) {
        this._Code = result.body.resultData.code;
        this.formedit.get('option').setValue(result.body.resultData.option);
        this.formedit.get('selected').setValue(result.body.resultData.selected);
        this.formedit.get('statusBol').setValue(result.body.resultData.status=='A'?true:false);
        this.formedit.get('control').setValue('x');
      }
      else {
        alert(result.body.error.description);
      }
    }, (e) => {
      alert(e);
      return;
    });
  }

  Cancel() {
    this.dialogRef.close();
  }

  Save() {
    try {
      let _Message = "";
      const _Data: UpdatePO = {
idPASOptions:this.id, status: (this.formedit.value.statusBol?'A':'I') ,
        option: this.formedit.value.option, selected: this.formedit.value.selected,
      };
      this.PASPrdService.UpdatePO(_Data).subscribe(result => {
            if (result.body.isValid) {
              _Message = result.body.resultData.description;
              this.openSB(_Message);
              this.dialogRef.close(true);
            }
            else {
              alert(result.body.error.description);
              return;
            }
          }, (e) => {
            alert(e);
            return;
          });
    }
    catch (e) {
      console.log(e.message);
      alert(e.message);
    }
  }

  hasError(nombreControl: string, validacion: string) {
    const control = this.formedit.get(nombreControl);
    return control.hasError(validacion);
  }

  openSB(msg) {
    this._snackBar.open(msg, '', {
      duration: 3000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }

  ngOnDestroy(): void {
  }
}
